import { useState } from 'react'
import { createPortal } from 'react-dom'
import Lightbox from './LightBox'
import './ProductCard.css'
import { WA_NUMBER } from '../constants'

export default function ProductCard({ product, waNumber }) {
  const [imgError, setImgError] = useState(false)
  const [lightbox, setLightbox] = useState(false)

  const waMsg = encodeURIComponent(
    `Hola! Me interesa: *${product.name}* ¿Tiene disponibilidad?`
  )
  const waUrl = `https://wa.me/${waNumber}?text=${waMsg}`

  return (
    <div className="product-card">
      {!imgError && product.image ? (
        <img
          className="product-img"
          src={product.image}
          alt={product.name}
          loading="lazy"
          onError={() => setImgError(true)}
          onClick={() => setLightbox(true)}
          style={{ cursor: 'zoom-in' }}
        />
      ) : (
        <div className="product-img-placeholder">
          <span>🥃</span>
          <span>Sin imagen</span>
        </div>
      )}
      <div className="product-footer">
        <p className="product-name">{product.name}</p>
        {product.price && (
          <p className="product-price">${product.price} MXN</p>
        )}
        {product.inStock !== false ? (
        <a
          className="wa-btn"
          href={waUrl}
          target="_blank"
          rel="noreferrer"
        >
          <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
            <path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.555 4.116 1.529 5.843L.057 23.982l6.305-1.654A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.891 0-3.667-.5-5.2-1.375l-.374-.22-3.862 1.013 1.031-3.764-.243-.386A9.937 9.937 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
          </svg>
          Lo quiero
        </a> ) : (
          <span className="wa-btn agotado">
            Temporalmente agotado
          </span>
        )}
        {lightbox && createPortal(
          <Lightbox
            product={product}
            onClose={() => setLightbox(false)}
          />
        , document.body)}
      </div>
    </div>
  )
}
